// extracted by mini-css-extract-plugin
export default {"desktop":"desktop","lcpFixer":"dz_3HpwH","mobile":"mobile"};